export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-800 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading font-bold text-background-50 mb-3 block">51动漫网</span>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              一站式免费动漫在线阅读平台，汇集日漫、国漫、韩漫等好看漫画，为您提供流畅的下拉式追更体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-home-line text-lg"></i>
              </a>
              <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-question-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#media" onClick={(e) => handleScroll(e, '#media')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精彩看点</a>
              <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a>
              <a href="#ranking" onClick={(e) => handleScroll(e, '#ranking')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门排行</a>
              <a href="#about" onClick={(e) => handleScroll(e, '#about')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门专题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <nav className="flex flex-col gap-2">
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">日漫专区</a>
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">国漫精选</a>
              <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">韩漫推荐</a>
              <a href="#updates" onClick={(e) => handleScroll(e, '#updates')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新更新</a>
              <a href="#topics" onClick={(e) => handleScroll(e, '#topics')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">话题标签</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 51动漫网 - 免费好看的动漫在线阅读大全。本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-6 text-xs text-background-500">
              <a href="#about" onClick={(e) => handleScroll(e, '#about')} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}